module.exports = __webpack_public_path__ + "img/7.700ab742.png";